import { useIsLoading } from "./useIsLoading";
import { useI18n } from "vue-i18n";
import { useFetch } from "nuxt/app";

export function useCustomFetch<T>(
  url: string | (() => string),
  options: any = {},
) {
  const { setIsLoading } = useIsLoading();
  const { locale } = useI18n();
  
  const loadingId = typeof url === 'string' ? url : url();

  return useFetch<T>(url, {
    ...options,
    headers: {
      ...options.headers,
      "Accept-Language": locale.value,
    },
    onRequest() {
      setIsLoading(true, loadingId);
    },
    onResponse() {
      setIsLoading(false, loadingId);
    },
    onResponseError() {
      setIsLoading(false, loadingId);
    },
  });
}
